{{each OnlyOneData item i}}
    <div class="item clearfix">
        <a  class="fl" href="./home.html?userid={{item.UserID}}">
            <img class="headPortrait" data-sex="{{item.Sex}}" src="{{item.DataUrl}}">
        </a>
        <div class="item-content" class="fl">
            <p>{{item.NickName}}</p>
            {{if userListType === 1 || userListType === 2}}
                <h4 class="p-my-tips">{{item.MyTips}}</h4>
            {{else if userListType === 3}}
                <div>
                    <span style="color:#FF5379;margin-right: 2em;">访问你{{item.TotalCount}}次</span><span style="color: #666;">最近访问：{{item.AddTime}}</span>
                </div>
            {{else userListType === 4}}
                <span style="color: #666;">{{item.AddTime}}</span>
            {{/if}}
            
        </div>
        {{if userListType === 1}}
            {{if item.CallStatus == 2 || item.CallStatus == 5}}
                <a class="op-btn fr linear-btn detailCallBtn" data-id="{{item.UserID}}">通话</a>
            {{else if item.CallStatus == -1 || item.CallStatus == 3 || item.CallStatus == 9 }}
                <a class="op-btn fr disabled-btn">不可通话</a>
            {{else if item.CallStatus == 1 || item.CallStatus == 4 || item.CallStatus == 6 || item.CallStatus == 7 || item.CallStatus == 8}}
                <a class="op-btn fr migic-btn detailMagicBtn" data-id="{{item.UserID}}">魔术唤醒</a>
            {{/if}}
        {{else if userListType === 2 }}
            {{if item.IsAttention == 0}}
                <a class="op-btn light-btn fr attentionListOpt" data-id="{{item.UserID}}">关注</a>
            {{else if item.IsAttention == 1}}
                <a class="op-btn has-follow fr attentionListOpt" data-id="{{item.UserID}}">已关注</a>
            {{/if}}
        {{else if userListType === 3 }}
            {{if item.IsFan == 0}}
                <a class="op-btn light-btn fr attentionListOpt" data-id="{{item.UserID}}">关注</a>
            {{else if item.IsFan == 1}}
                <a class="op-btn has-follow fr attentionListOpt" data-id="{{item.UserID}}">已关注</a>
            {{/if}}
        {{else if userListType === 4}}
            <a class="op-btn light-btn fr blackListOpt" data-id="{{item.UserID}}">移出黑名单</a>
            <!--
                <a class="op-btn dark-btn fr blackListOpt">加入黑名单</a>
            -->
        {{/if}}
    </div>
{{/each}}